import { PRODUCT_CARD_CAROUSEL_CHANGE } from './productCardCarouselChange';
import { PRODUCT_CARD_CAROUSEL_ARROW_CLICK } from './productCardCarouselArrowClick';
import { PRODUCT_CARD_CAROUSEL_UPDATE } from './productCardCarouselUpdate';
import { PRODUCT_VIEW } from './productView';
import { PRODUCT_IMAGE_CAROUSEL_UPDATE } from './productImageCarouselUpdate';
import { YOTPO_INIT } from './yotpoInit';
import { REVIEW_WIDGET_CLICK } from './reviewWidgetClick';
import { EMAIL_UNSUBSCRIBE } from './emailUnsubscribe';
import { CUSTOMER_ACTIVATE } from './customerActivate';
import { CUSTOMER_LOGIN } from './customerLogin';
import { CUSTOMER_SIGNUP } from './customerSignup';
import { CUSTOMER_PASSWORD_UPDATE } from './customerPasswordUpdate';
import { MINICART_OPEN } from './minicartOpen';
import { MINICART_CHECKOUT_CLICK } from './minicartCheckoutClick';
import { BUCKET_ASSIGN } from './bucketAssign';
import { CART_ADD } from './cartAdd';
import { CART_REMOVE } from './cartRemove';
import { CART_INCREMENT } from './cartIncrement';
import { COUPON_MODAL_LAUNCH } from './couponModalLaunch';
import { COUPON_MODAL_CLOSE } from './couponModalClose';
import { COUPON_MODAL_EMAIL_STEP_VIEW } from './couponModalEmailStepView';
import { COUPON_MODAL_SMS_STEP_VIEW } from './couponModalSmsStepView';
import { COUPON_MODAL_MICRO_YES_STEP_VIEW } from './couponModalMicroYesStepView';
import { COUPON_FAB_CLOSE } from './couponFabClose';
import { COUPON_FAB_CLICK } from './couponFabClick';
import { COUPON_FAB_VIEW } from './couponFabView';
import { COUPON_MODAL_EMAIL_LIST_SUCCESS } from './couponModalEmailListSuccess';
import { COUPON_MODAL_EMAIL_LIST_FAIL } from './couponModalEmailListFail';
import { COUPON_MODAL_SMS_SUCCESS } from './couponModalSmsSuccess';
import { QBS_MODAL_OPEN } from './qbsModalOpen';
import { NOTIFY_ME_SUBSCRIBE } from './notifyMeSubscribe';
import { PRODUCT_DETAILS_CLICK } from './productDetailsClick';
import { FPD_FEATURES_LIST_CLICK } from './fpdFeaturesListClick';
import { PRODUCT_DETAILS_QUICKVIEW_CLICK } from './productDetailsQuickviewClick';
import { SIZE_GUIDE_LINK_CLICK } from './sizeGuideLinkClick';
import { PACK_MODE_SINGLES_SELECT } from './packModeSinglesSelect';
import { PACK_MODE_PACKS_SELECT } from './packModePacksSelect';
import { PACK_SLIDER_CLICK } from './packSliderClick';
import { FREE_SHIPPING_RETURNS_BUTTON_ROW_CLICK } from './freeShippingReturnsButtonRowClick';
import { ZOOM_LAUNCH } from './zoomLaunch';
import { PRODUCT_CARDS_IN_UPSELL_CAROUSEL_CLICK } from './productCardsInUpsellCarouselClick';
import { PRODUCT_CARD_COLOR_SWATCH_CLICK } from './productCardColorSwatchClick';
import { PRODUCT_CARD_SEE_MORE_CLICK } from './productCardSeeMoreClick';
import { PRODUCT_TILE_CLICK } from './productTileClick';
import { QBS_TIER_SELECT } from './qbsTierSelect';
import { REBUY_UPSELL_CART_ADD } from './rebuyUpsellCartAdd';
import { COUPON_MODAL_SMS_FAIL } from './couponModalSmsFail';
import { COUPON_MODAL_CONTINUE_SHOPPING_CLICK } from './couponModalContinueShoppingClick';
import { COUPON_MODAL_MICRO_YES_CLICK } from './couponModalMicroYesClick';
import { COUPON_MODAL_DID_NOT_BOUNCE } from './couponModalDidNotBounce';
import { OPTIMIZELY_NEW_VISITOR_SEGMENT } from './optimizelyNewVisitorSegment';
import { HOMEPAGE_VIEW } from './homepageView';
import { CART_VIEW } from './cartView';
import { CART_SYNC } from './cartSync';
import { CART_ADD_PDP } from './cartAddPDP';
import { CART_ADD_PCP } from './cartAddPCP';
import { CART_ADD_QUICKVIEW } from './cartAddQuickView';
import { CART_CHECKOUT_CLICK } from './cartCheckoutClick';
import { GIFT_OPTIONS_PROMPT_CLICK } from './giftOptionsPromptClick';
import { GIFT_MESSAGE_PROMPT_CLICK } from './giftMessagePromptClick';
import { DISCOUNT_CODE_APPLY } from './discountCodeApply';
import { PDP_BREADCRUMBS_LINK_CLICK } from './pdpBreadcumbsLinkClick';
import { PDP_PRESELECTED_COLOR_REJECTED } from './pdpPreselectedColorRejected';
import { PDP_VIEW } from './pdpView';
import { PDP_COLOR_SWATCH_CLICK } from './pdpColorSwatchClick';
import { PDP_SIZE_SELECTOR_CLICK } from './pdpSizeSelectorClick';
import { QUICKVIEW_COLOR_SWATCH_CLICK } from './quickviewColorSwatchClick';
import { QUICKVIEW_SIZE_SELECTOR_CLICK } from './quickviewSizeSelectorClick';
import { QUICKVIEW_PDP_BREADCRUMB_CLICK } from './quickviewPDPBreadcrumbClick';
import { PCP_PRODUCT_CARD_CLICK_TO_PDP } from './pcpProductCardClickToPDP';
import { FILTER_OPTION_DESELECT } from './filterOptionDeselect';
import { FILTER_OPTION_SELECT } from './filterOptionSelect';
import { FILTER_CATEGORY_SELECT } from './filterCategorySelect';
import { SORT_SELECT } from './sortSelect';
import { SORT_OPTION_SELECT } from './sortOptionSelect';
import { QUICKADD_CLICK } from './quickaddClick';
// Event names are derived from the keys in EventMap and should follow
// the Noun-Verb convention to make it easier to identify all events related to a given noun.
// Combination event nouns should be ordered from least-to-most specificity.
// Example: "CART_ADD" instead of "ADD_TO_CART".
export var EventMap = {
    YOTPO_INIT: YOTPO_INIT,
    REVIEW_WIDGET_CLICK: REVIEW_WIDGET_CLICK,
    EMAIL_UNSUBSCRIBE: EMAIL_UNSUBSCRIBE,
    CUSTOMER_ACTIVATE: CUSTOMER_ACTIVATE,
    CUSTOMER_LOGIN: CUSTOMER_LOGIN,
    CUSTOMER_SIGNUP: CUSTOMER_SIGNUP,
    CUSTOMER_PASSWORD_UPDATE: CUSTOMER_PASSWORD_UPDATE,
    PRODUCT_CARD_CAROUSEL_CHANGE: PRODUCT_CARD_CAROUSEL_CHANGE,
    PRODUCT_CARD_CAROUSEL_ARROW_CLICK: PRODUCT_CARD_CAROUSEL_ARROW_CLICK,
    PRODUCT_CARD_CAROUSEL_UPDATE: PRODUCT_CARD_CAROUSEL_UPDATE,
    PRODUCT_VIEW: PRODUCT_VIEW,
    PRODUCT_IMAGE_CAROUSEL_UPDATE: PRODUCT_IMAGE_CAROUSEL_UPDATE,
    MINICART_OPEN: MINICART_OPEN,
    MINICART_CHECKOUT_CLICK: MINICART_CHECKOUT_CLICK,
    BUCKET_ASSIGN: BUCKET_ASSIGN,
    CART_ADD: CART_ADD,
    CART_REMOVE: CART_REMOVE,
    CART_INCREMENT: CART_INCREMENT,
    COUPON_MODAL_LAUNCH: COUPON_MODAL_LAUNCH,
    COUPON_MODAL_CLOSE: COUPON_MODAL_CLOSE,
    COUPON_MODAL_EMAIL_STEP_VIEW: COUPON_MODAL_EMAIL_STEP_VIEW,
    COUPON_MODAL_SMS_STEP_VIEW: COUPON_MODAL_SMS_STEP_VIEW,
    COUPON_MODAL_MICRO_YES_STEP_VIEW: COUPON_MODAL_MICRO_YES_STEP_VIEW,
    COUPON_FAB_CLOSE: COUPON_FAB_CLOSE,
    COUPON_FAB_CLICK: COUPON_FAB_CLICK,
    COUPON_FAB_VIEW: COUPON_FAB_VIEW,
    COUPON_MODAL_EMAIL_LIST_SUCCESS: COUPON_MODAL_EMAIL_LIST_SUCCESS,
    COUPON_MODAL_EMAIL_LIST_FAIL: COUPON_MODAL_EMAIL_LIST_FAIL,
    COUPON_MODAL_SMS_SUCCESS: COUPON_MODAL_SMS_SUCCESS,
    COUPON_MODAL_SMS_FAIL: COUPON_MODAL_SMS_FAIL,
    COUPON_MODAL_CONTINUE_SHOPPING_CLICK: COUPON_MODAL_CONTINUE_SHOPPING_CLICK,
    COUPON_MODAL_MICRO_YES_CLICK: COUPON_MODAL_MICRO_YES_CLICK,
    COUPON_MODAL_DID_NOT_BOUNCE: COUPON_MODAL_DID_NOT_BOUNCE,
    QBS_MODAL_OPEN: QBS_MODAL_OPEN,
    NOTIFY_ME_SUBSCRIBE: NOTIFY_ME_SUBSCRIBE,
    PRODUCT_DETAILS_CLICK: PRODUCT_DETAILS_CLICK,
    FPD_FEATURES_LIST_CLICK: FPD_FEATURES_LIST_CLICK,
    PRODUCT_DETAILS_QUICKVIEW_CLICK: PRODUCT_DETAILS_QUICKVIEW_CLICK,
    SIZE_GUIDE_LINK_CLICK: SIZE_GUIDE_LINK_CLICK,
    PACK_SLIDER_CLICK: PACK_SLIDER_CLICK,
    PACK_MODE_PACKS_SELECT: PACK_MODE_PACKS_SELECT,
    PACK_MODE_SINGLES_SELECT: PACK_MODE_SINGLES_SELECT,
    FREE_SHIPPING_RETURNS_BUTTON_ROW_CLICK: FREE_SHIPPING_RETURNS_BUTTON_ROW_CLICK,
    ZOOM_LAUNCH: ZOOM_LAUNCH,
    PRODUCT_CARDS_IN_UPSELL_CAROUSEL_CLICK: PRODUCT_CARDS_IN_UPSELL_CAROUSEL_CLICK,
    PRODUCT_CARD_SEE_MORE_CLICK: PRODUCT_CARD_SEE_MORE_CLICK,
    PRODUCT_CARD_COLOR_SWATCH_CLICK: PRODUCT_CARD_COLOR_SWATCH_CLICK,
    PRODUCT_TILE_CLICK: PRODUCT_TILE_CLICK,
    QBS_TIER_SELECT: QBS_TIER_SELECT,
    REBUY_UPSELL_CART_ADD: REBUY_UPSELL_CART_ADD,
    OPTIMIZELY_NEW_VISITOR_SEGMENT: OPTIMIZELY_NEW_VISITOR_SEGMENT,
    HOMEPAGE_VIEW: HOMEPAGE_VIEW,
    CART_VIEW: CART_VIEW,
    CART_SYNC: CART_SYNC,
    CART_ADD_PDP: CART_ADD_PDP,
    CART_ADD_PCP: CART_ADD_PCP,
    CART_ADD_QUICKVIEW: CART_ADD_QUICKVIEW,
    CART_CHECKOUT_CLICK: CART_CHECKOUT_CLICK,
    GIFT_OPTIONS_PROMPT_CLICK: GIFT_OPTIONS_PROMPT_CLICK,
    GIFT_MESSAGE_PROMPT_CLICK: GIFT_MESSAGE_PROMPT_CLICK,
    DISCOUNT_CODE_APPLY: DISCOUNT_CODE_APPLY,
    PDP_BREADCRUMBS_LINK_CLICK: PDP_BREADCRUMBS_LINK_CLICK,
    PDP_COLOR_SWATCH_CLICK: PDP_COLOR_SWATCH_CLICK,
    PDP_SIZE_SELECTOR_CLICK: PDP_SIZE_SELECTOR_CLICK,
    PDP_PRESELECTED_COLOR_REJECTED: PDP_PRESELECTED_COLOR_REJECTED,
    PDP_VIEW: PDP_VIEW,
    PCP_PRODUCT_CARD_CLICK_TO_PDP: PCP_PRODUCT_CARD_CLICK_TO_PDP,
    QUICKVIEW_COLOR_SWATCH_CLICK: QUICKVIEW_COLOR_SWATCH_CLICK,
    QUICKVIEW_SIZE_SELECTOR_CLICK: QUICKVIEW_SIZE_SELECTOR_CLICK,
    QUICKVIEW_PDP_BREADCRUMB_CLICK: QUICKVIEW_PDP_BREADCRUMB_CLICK,
    FILTER_OPTION_DESELECT: FILTER_OPTION_DESELECT,
    FILTER_OPTION_SELECT: FILTER_OPTION_SELECT,
    FILTER_CATEGORY_SELECT: FILTER_CATEGORY_SELECT,
    SORT_SELECT: SORT_SELECT,
    SORT_OPTION_SELECT: SORT_OPTION_SELECT,
    QUICKADD_CLICK: QUICKADD_CLICK
};
